export default {
  mounted(el, binding) {
    let isProcessing = false;
    let originalDisabled = el.disabled;

    const handler = async (event) => {
      if (isProcessing) return;
      isProcessing = true;
      originalDisabled = el.disabled;
      el.disabled = true;

      const useLoading = binding.modifiers.load;

      if (useLoading) {
        const instance = el.__vueParentComponent?.ctx || el.__vnode?.component?.ctx;



        if (instance && instance.isLoading !== undefined) {
          instance.$data.isLoading = true;
        } else {
          el.classList.add("element-load");
        }
      }

      try {
        await binding.value(event);
      } finally {

        if (useLoading) {
          const instance = el.__vueParentComponent?.ctx || el.__vnode?.component?.ctx;

          if (instance && instance.isLoading !== undefined) {
            instance.$data.isLoading = false;
          } else {
            el.classList.remove("element-load");
          }
        }

        el.disabled = originalDisabled;
        isProcessing = false;
      }
    };

    el.addEventListener("click", handler);
    el.__singleClickHandler__ = handler;
  },
  unmounted(el) {
    el.removeEventListener("click", el.__singleClickHandler__);
    delete el.__singleClickHandler__;
  }
};
